import { makeContextModule } from 'shared/map-search/utils/makeContextModule';

export interface INewbuildingPolygonsContext {
  newbuildingsPolygonsManager: YMaps.NewbuildingsPolygonsManager;
}

export const {
  Context: NewbuildingPolygonsContext,
  useContext: useNewbuildingPolygonsContext,
  withContext: withNewbuildingPolygonsContext,
} = makeContextModule<INewbuildingPolygonsContext>({
  contextName: 'NewbuildingPolygonsContext',
});
